import { useMemo } from "react";
import type { SessionUser } from "../../../../shared/auth/access";
import { useWorkspaceScope } from "../../../../shared/hooks/useWorkspaceScope";

export function useProcurementScope(requestNo: string, user: SessionUser, notify: (message: string) => void) {
  const key = JSON.stringify([requestNo, user.id, user.role, user.roles, user.permissions, user.dataScope, user.departmentId, user.preview, user.previewRole]);
  const scope = useWorkspaceScope(key, notify);
  return useMemo(() => ({ ...scope, requestNo }), [scope, requestNo]);
}
export type ProcurementScope = ReturnType<typeof useProcurementScope>;
